var map = {
	"./banhanguytin/8.png": "4578",
	"./cacung/8.png": "2c44",
	"./chuyencan/8.png": "829e",
	"./daigiadataha/8.png": "f49f",
	"./duhanhgia/8.png": "0b7e",
	"./thanhsanma/8.png": "fa21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fcf9";